<template>
  <section id="main" class="main-viewport">
    <div class="subpage-banner py-4 img-only" style="background-image:url('images/banners/subpage-banner.jpg');">
      &nbsp;
    </div>
    <div class="subpage-content content-wrap mh-auto">
      <div class="container py-4 text-container">
        <div class="row no-gutters">
          <div class="col-12 col-lg-10 offset-lg-1 pt-3 privacy-policy">
            <h1>Privacy Policy</h1>
            <p><strong>Effective date:</strong> July 11, 2026</p>
            <p><strong>Last updated:</strong> July 11, 2026</p>

            <h2>Overview</h2>
            <p>
              Viberary provides a music and sound-effects library for creators. This policy explains
              what information Viberary collects when people browse the site, download audio, request
              commercial-use permission, contact Viberary, or use pages that include analytics or
              advertising.
            </p>

            <h2>Personal-Use Downloads</h2>
            <p>
              Personal-use downloads do not require an account, full name, company name, company
              email, or other personal details. Viberary may record a non-personal download count for
              the selected track or sound effect.
            </p>

            <h2>Commercial-Use Requests</h2>
            <p>
              When a visitor chooses commercial use, Viberary asks for full name, company name, and
              company email. The system also records the selected track or sound effect through its
              internal music ID, the requested download version, a download code, and submission or
              download timestamps where applicable.
            </p>
            <p>
              Viberary uses this information to create and communicate the commercial-use download
              link, to keep a record of the permission associated with that request, and to
              communicate with the requester about that permission. Commercial-use information is not
              used for advertising and is not shared with ad networks.
            </p>

            <h2>Contact Inquiries</h2>
            <p>
              The Contact page collects full name, email address, country, phone number, optional
              company, subject, message, and a reCAPTCHA response. Contact submissions are sent to
              Viberary by email so support, licensing, ownership, partnership, or site questions can
              be answered.
            </p>

            <h2>Technical and Server Information</h2>
            <p>
              Like most websites, Viberary's hosting and application systems may record technical
              information such as pages requested, request times, browser and device information,
              referring page where available, IP address, error details, and security-related log
              entries. These records are used to operate the site, diagnose technical problems, and
              protect the service.
            </p>

            <h2>Google Analytics</h2>
            <p>
              Viberary uses Google Analytics 4 with Measurement ID G-63R31Z6Q2C to understand site
              usage, page views, audio interactions, category browsing, download-page interactions,
              and site performance.
            </p>
            <p>
              Google Analytics may use cookies or similar technologies to measure how visitors use
              the site. Viberary keeps Google advertising consent states denied because it is not
              using Google Ads personalization or Google remarketing in this setup.
            </p>
            <p>
              Google Analytics may process page location, page title, browser and device details,
              approximate geographic information, referral or campaign information, analytics
              identifiers, and first-party analytics cookies. Viberary does not intentionally send
              full names, company names, company emails, phone numbers, contact messages,
              commercial-use form contents, or search terms to Google Analytics.
            </p>

            <h2>Cookies and Browser Storage</h2>
            <p>
              Viberary displays a compact cookie notice and stores a first-party acknowledgement
              cookie named <code>viberary_cookie_notice</code> after a visitor clicks Accept. Google
              Analytics may set first-party cookies such as <code>_ga</code> and
              <code>_ga_63R31Z6Q2C</code>. Visitors can use browser settings, private browsing,
              content blockers, or other privacy tools to block or delete cookies.
            </p>

            <h2>Advertising</h2>
            <p>
              Viberary uses Adsterra to show advertising and support the free music library. Ads may
              appear on public music, sound-effects, and download pages. Advertising partners may
              process technical ad-related information such as page URL, browser and device
              information, IP address, approximate location, ad impressions, clicks, and cookie or
              similar identifiers where applicable.
            </p>
            <p>
              Viberary does not intentionally send commercial-use form details, contact-form
              details, names, company names, phone numbers, email addresses, or messages to Adsterra
              or Google Analytics. Commercial-use details are not used for advertising and are not
              shared with ad networks. A full regional advertising consent platform is not currently
              installed.
            </p>

            <h2>Service Providers</h2>
            <p>
              Viberary uses hosting and infrastructure providers, email delivery or form-processing
              services where needed for contact and commercial-use messages, Google reCAPTCHA on the
              Contact page, Google Analytics through the consent behavior described above, and
              advertising partners such as Adsterra where enabled on public pages.
            </p>

            <h2>Retention</h2>
            <p>
              Commercial-use records and contact emails are kept as long as needed to administer
              license records, respond to inquiries, operate the site, and protect legitimate site
              interests. Server and security logs are kept according to the hosting and operational
              practices in use at the time. Google Analytics event data is retained according to the
              retention setting configured in Viberary's Google Analytics property.
            </p>

            <h2>Sharing</h2>
            <p>
              Viberary shares information with service providers only as needed to operate,
              maintain, secure, measure, and support the site. Viberary does not use commercial-use
              or contact-form personal details as Google Analytics event parameters, and
              commercial-use information is not used for advertising or shared with ad networks.
            </p>

            <h2>Security and Choices</h2>
            <p>
              Viberary uses reasonable technical and operational measures to protect the site, but no
              online service can guarantee perfect security. Visitors can avoid submitting contact or
              commercial-use information unless they need those services, and they can use browser
              controls or privacy tools to manage cookies.
            </p>

            <h2>Contact</h2>
            <p>
              Privacy, licensing, ownership, partnership, and support inquiries can be submitted
              through the <router-link to="/contact-us">Contact page</router-link>.
            </p>
          </div>
        </div>
      </div>
    </div>
    <SubFooter />
  </section>
</template>

<script>
import SubFooter from "../partials/SubFooter.vue";

export default {
  components: {
    SubFooter,
  }
}
</script>

<style scoped>
.privacy-policy h2 {
  font-size: 24px;
  margin-top: 28px;
}
.privacy-policy code {
  background: rgba(0,0,0,0.06);
  border-radius: 4px;
  padding: 1px 4px;
}
</style>
